var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_2635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1499 5C6.1164 5 6.8999 4.2165 6.8999 3.25C6.8999 2.2835 6.1164 1.5 5.1499 1.5C4.1834 1.5 3.3999 2.2835 3.3999 3.25C3.3999 4.2165 4.1834 5 5.1499 5Z",
    stroke: "#F15802",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55127 1.75C9.05947 2.05623 9.39937 2.61343 9.39937 3.25C9.39937 3.88657 9.05947 4.44377 8.55127 4.75",
    stroke: "#FE9F69",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3999 10.2V10.5H8.8999V10.2C8.8999 9.0799 8.8999 8.51985 8.68193 8.09202C8.49018 7.7157 8.1842 7.40973 7.80788 7.21798C7.38005 7 6.82 7 5.6999 7H4.5999C3.4798 7 2.91975 7 2.49192 7.21798C2.1156 7.40973 1.80963 7.7157 1.61789 8.09202C1.3999 8.51985 1.3999 9.0799 1.3999 10.2Z",
    stroke: "#F15802",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3992 10.4998V10.1998C11.3992 9.07967 11.3992 8.51962 11.1812 8.0918C10.9894 7.71547 10.6835 7.40952 10.3071 7.21777",
    stroke: "#FE9F69",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_2635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.5240a0b4ce7b1fe49a41a68bd3383ab5.svg";
export { ForwardRef as ReactComponent };